import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';

export const getCustomerDisplayName = (data: StaffAccountBasicDataType): string => {
    const trimmedFirstName = (data.firstName ?? '').trim();
    return trimmedFirstName === '' ? data.name : `${trimmedFirstName} ${data.surname ?? ''}`.trim();
};
